export const BANKING_SCOPE = {
  CUSTOMER_READ: 'customers:read',
  CUSTOMER_WRITE: 'customers:write',
  ACCOUNT_READ: 'accounts:read',
  ACCOUNT_WRITE: 'accounts:write',
  DOCUMENTS_READ: 'documents:read',
  DOCUMENTS_WRITE: 'documents:write',
  TRANSFER_READ: 'transfers:read',
  TRANSFER_WRITE: 'transfers:write',
  TRANSACTIONS_READ: 'transactions:read',
  TRANSACTIONS_WRITE: 'transactions:write',
  LOAN_READ: 'loans:read',
  LOAN_WRITE: 'loans:write',
  RDC_REQUESTS_READ: 'rdc-requests:read',
  RDC_ACCOUNTS_READ: 'rdc-accounts:read',
  RDC_ACCOUNTS_WRITE: 'rdc-accounts:write',
  RDC_VELOCITY_READ: 'rdc-velocity:read',
  RDC_VELOCITY_WRITE: 'rdc-velocity:write',
  PREQUAL_READ: 'prequal:read',
  PREQUAL_WRITE: 'prequal:write',
  HARDPULL_READ: 'hardpull:read',
  HARDPULL_WRITE: 'hardpull:write'
} as const

export type BankingScope = (typeof BANKING_SCOPE)[keyof typeof BANKING_SCOPE]

export const ALL_BANKING_SCOPES: BankingScope[] = Object.values(BANKING_SCOPE)

/** All Online Banking Admin RDC scopes — request these from /api/oauth/token for admin RDC APIs. */
export const ALL_RDC_ADMIN_SCOPES: readonly BankingScope[] = [
  BANKING_SCOPE.RDC_REQUESTS_READ,
  BANKING_SCOPE.RDC_ACCOUNTS_READ,
  BANKING_SCOPE.RDC_ACCOUNTS_WRITE,
  BANKING_SCOPE.RDC_VELOCITY_READ,
  BANKING_SCOPE.RDC_VELOCITY_WRITE
]
